// Module
var code = "<p class=\"circle\">2</p> <p>Select <strong>Make a Payment.</strong></p> ";
// Exports
export default code;